import {
  getAllImage,
  getImageGalleryData,
  getSelectedbundleDetails,
  getSelectedImageGallaryDetails,
  isSkuBackOrderable,
  getSelectedProductPrices,
} from "@/components/MultiFinshProductBundle/utils"
import { sanitizeTextForAnalytics } from "@/utils/helper"

export const getProductInfo = ({
  data = {},
  skusPrice = [],
  siteName = "",
  swatchName = "",
}) => {
  const {
    pdpDetails = {},
    inventory = [],
    selectedProducts = [],
    bundleItems = [],
    projectionData = [],
    imageGallery: { bundleListImages = [] } = {},
  } = data

  const selectedSkus = selectedProducts.map(item => item?.sku)
  const selectedSkusDetails = getSelectedImageGallaryDetails(
    bundleListImages,
    selectedSkus
  )
  const selectedImageDetails = selectedSkus.map((sku, index) => {
    return getImageGalleryData(selectedSkusDetails[index], sku)
  })
  const { intialimages } = getAllImage(
    selectedSkusDetails,
    selectedImageDetails
  )

  const bundlePrice = skusPrice.reduce((acc, item) => {
    const { priceProduct = 0, discountPrice = 0 } = item || {}
    const price = discountPrice > 0 ? discountPrice : priceProduct
    const finalPrice = Number(price) || 0
    return acc + finalPrice
  }, 0)

  const { sku: bundleSku = "" } = pdpDetails
  const pData = getSelectedbundleDetails({
    selectedSkus: selectedSkus,
    data: bundleItems,
  })

  const productInfodata = skusPrice.map((each, index) => {
    const { sku = "", priceProduct = 0, discountPrice = 0 } = each || {}
    const productSkuKey = sku?.split("-").slice(0, -1).join("-")

    const eachProduct =
      pData.find(item => item.sku.includes(productSkuKey)) || {}

    const {
      title = "",
      primaryCategory = "",
      category: localcategory = "",
      productBrandName = "",
      productName = "",
      regionBrandName = "",
      productWaterSense = false,
    } = eachProduct || {}

    const primaryCategoryS = sanitizeTextForAnalytics(primaryCategory)
    const productBrandNameS = sanitizeTextForAnalytics(productBrandName)

    const price = Number(priceProduct) || 0
    const discount = Number(discountPrice) || 0

    const commonProductInfo = {
      bundleIds: `K-${bundleSku}`,
      bundleProductColors: sanitizeTextForAnalytics(swatchName),
      bundlePrice: Number(bundlePrice.toFixed(2)),
      pdpType: "bundle",
    }

    const { availableQuantity = 0 } =
      inventory.find(item => item.sku === sku) || {}

    const isBackOrder = isSkuBackOrderable({
      data: projectionData,
      sku: sku,
    })

    const productStatus =
      availableQuantity > 0
        ? "in stock"
        : isBackOrder
        ? "back order"
        : "out of stock"

    const eachProductInfodata = {
      category: primaryCategoryS || "n/a",
      description: sanitizeTextForAnalytics(title) || "n/a",
      defaultImageName: intialimages[index]?.url || "n/a",
      frequency: "n/a",
      globalDiscount: discount || 0,
      globalOffer: "n/a",
      globalPromotionPrice: price || 0,
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      itemType: primaryCategoryS || "n/a",
      numberOfReviews: "n/a",
      priceState: "regular price",
      productBasePrice: priceProduct || 0,
      productBrand: sanitizeTextForAnalytics(siteName),
      productCategory: sanitizeTextForAnalytics(localcategory) || "n/a",
      productCollectionsName: productBrandNameS || "n/a",
      productColor: sanitizeTextForAnalytics(swatchName),
      productCouponCode: "n/a",
      productCoupondiscount: 0,
      productFindingMethod: "n/a",
      productID: `K-${sku}`,
      productName:
        productBrandNameS ||
        sanitizeTextForAnalytics(regionBrandName || productName) ||
        "n/a",
      productPartnerBuyNow: "false",
      productRoom: primaryCategoryS || "n/a",
      productSalePrice:
        discountPrice > 0 ? Number((discount - 0).toFixed(2)) : price,
      productSaleable: true,
      productStatus: productStatus,
      productSuperSku: false,
      productTileName: productBrandNameS || "n/a",
      quantity: 1,
      ratings: "n/a",
      waterSenseProduct: productWaterSense ? "true" : "false",
    }

    return { ...commonProductInfo, ...eachProductInfodata }
  })

  return productInfodata
}

export const getProductInfoForAnalytics = data => {
  const {
    productName,
    sku,
    category,
    title,
    siteName,
    productBrandName,
    swatchName,
    productWaterSense = [],
    inventory = [],
    projectionData = [],
    regionBrandName = "",
    persona,
    currencyCode = "",
    bundleListImages = [],
  } = data

  const categoryS = sanitizeTextForAnalytics(category)
  const productBrandNameS = sanitizeTextForAnalytics(productBrandName)

  const { availableQuantity = 0 } =
    inventory.find(item => item.sku === sku) || {}

  const isBackOrder = isSkuBackOrderable({
    data: projectionData,
    sku: sku,
  })

  const productStatus =
    availableQuantity > 0
      ? "in stock"
      : isBackOrder
      ? "back order"
      : "out of stock"

  const skuPrice = getSelectedProductPrices({
    productLists: projectionData,
    skus: [sku],
    currencyCode,
    persona,
  })

  const { priceProduct = 0, discountPrice = 0 } = skuPrice[0] || {}
  const price = Number(priceProduct) || 0
  const discount = Number(discountPrice) || 0

  const imageGalleryDetails = getSelectedImageGallaryDetails(bundleListImages, [
    sku,
  ])
  const imageDetails = getImageGalleryData(imageGalleryDetails[0], sku)
  const { intialimages } = getAllImage(imageGalleryDetails, [imageDetails])

  const productInfo = {
    category: categoryS || "n/a",
    description: sanitizeTextForAnalytics(title) || "n/a",
    defaultImageName: intialimages[0]?.url || "n/a",
    frequency: "n/a",
    globalDiscount: discount || 0,
    globalOffer: "n/a",
    globalPromotionPrice: price || 0,
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    itemType: categoryS || "n/a",
    numberOfReviews: "n/a",
    priceState: "regular price",
    productBasePrice: priceProduct || 0,
    productBrand: sanitizeTextForAnalytics(siteName),
    productCategory: categoryS || "n/a",
    productCollectionsName: productBrandNameS || "n/a",
    productColor: sanitizeTextForAnalytics(swatchName),
    productCouponCode: "n/a",
    productCoupondiscount: 0,
    productFindingMethod: "n/a",
    productID: `K-${sku}`,
    productName:
      productBrandNameS ||
      sanitizeTextForAnalytics(regionBrandName || productName) ||
      "n/a",
    productPartnerBuyNow: "false",
    productRoom: categoryS || "n/a",
    productSalePrice:
      discountPrice > 0 ? Number((discount - 0).toFixed(2)) : price,
    productSaleable: true,
    productStatus: productStatus,
    productSuperSku: false,
    productTileName: productBrandNameS || "n/a",
    quantity: 1,
    ratings: "n/a",
    waterSenseProduct: productWaterSense[0] === "Yes" ? "true" : "false",
  }
  return productInfo
}
